<template>
  <div class="ChatHistory">
    <div class="d-lg-flex">
      <h5 class="intro-title text-xl">我的對話記錄</h5>
      <div class="d-flex text-sm">
        <div class="custom-dropdown mx-1">
          <select v-model="time">
            <option :value="null" disabled>時間</option>
            <option>1</option>
          </select>
        </div>
        <div class="custom-dropdown mx-1">
          <select v-model="theme">
            <option :value="null" disabled>場景</option>
            <option>1</option>
          </select>
        </div>
        <div class="custom-dropdown mx-1">
          <select v-model="context">
            <option :value="null" disabled>主題</option>
            <option>1</option>
          </select>
        </div>
        <div class="custom-dropdown mx-1">
          <select v-model="setting">
            <option :value="null" disabled>聊天設定</option>
            <option>1</option>
          </select>
        </div>
      </div>
    </div>
    <Table :columns="tableList.columns"
      :data="tableList.datas">
        <template slot="actionsLabel">
          <th class="whitespace-no-wrap text-center">第一次儲存時間</th>
          <th class="whitespace-no-wrap text-center">最近一次更新</th>
          <th class="whitespace-no-wrap text-center">場景主題</th>
          <th class="whitespace-no-wrap text-center">聊天設定</th>
          <th class="whitespace-no-wrap text-center">功能</th>
        </template>
        <!-- slot-scope="props" -->
        <template slot="actionsBtn">
          <td data-th="第一次儲存時間">
            2024/05/20　20:30:05
          </td>
          <td data-th="最近一次更新">
            2024/05/20　20:30:05
          </td>
          <td data-th="場景主題">
            機場>查詢航班
          </td>
          <td data-th="聊天設定">
            女聲 / 英國腔
          </td>
          <td data-th="功能">
            <a class="m-1 table-btn-actions rounded d-inline-block pointer">
              <img src="@/assets/image/ai/btn_score.png" alt="" class=" object-contain">
            </a>
            <a class="m-1 table-btn-actions rounded d-inline-block pointer">
              <img src="@/assets/image/ai/btn_continue.png" alt="" class=" object-contain">
            </a>
            <a class="m-1 table-btn-actions rounded d-inline-block pointer">
              <img src="@/assets/image/ai/btn_del.png" alt="" class=" object-contain">
            </a>
          </td>
        </template>
    </Table>
    <pagination v-if="pageCount > 1 && tableList.datas.length > 0" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
  </div>
</template>

<script>
  import Table from '@/components/AiHelper/table'
  import Pagination from '@/components/AiHelper/pagination'
  export default {
    name: 'ChatHistory',
    components: {
      Table,
      Pagination
    },
    data () {
      return {
        time: null,
        theme: null,
        context: null,
        setting: null,

        tableList: {
          columns: [
          ],
          datas: [{"id":16966,"name":"李英英3","sex":null,"email":"peggylee03@test.com","role":"student","created_at":"2023-12-21 10:09","points":0,"mobile":"0910002426","supervisor":"peggy_lee@liveabc.com","is_email_verified":0,"experience":null,"country":null,"continent":null,"is_promote":0,"is_mobile_verified":0,"service_name":"default","company":"總公司","department":"C","due_at":null,"name_en":"Peggylee03","city":null,"company_type":"","note":null,"photo_url":"https://livetalk-dev.liveabc.com/images/default-user.png","display_name":"Peggylee03","is_line_notify_connect":false},{"id":16965,"name":"李英英2","sex":null,"email":"peggylee02@test.com","role":"student","created_at":"2023-12-21 10:09","points":0,"mobile":"0932089502","supervisor":"peggy_lee@liveabc.com","is_email_verified":0,"experience":null,"country":null,"continent":null,"is_promote":0,"is_mobile_verified":0,"service_name":"default","company":"總公司","department":"B","due_at":null,"name_en":"Peggylee02","city":null,"company_type":"","note":null,"photo_url":"https://livetalk-dev.liveabc.com/images/default-user.png","display_name":"Peggylee02","is_line_notify_connect":false},{"id":16964,"name":"李英英1","sex":null,"email":"peggylee01@test.com","role":"student","created_at":"2023-12-21 10:09","points":0,"mobile":"0932089502","supervisor":"peggy_lee@liveabc.com","is_email_verified":0,"experience":null,"country":null,"continent":null,"is_promote":0,"is_mobile_verified":0,"service_name":"default","company":"總公司","department":"A","due_at":null,"name_en":"Peggylee01","city":null,"company_type":"","note":null,"photo_url":"https://livetalk-dev.liveabc.com/images/default-user.png","display_name":"Peggylee01","is_line_notify_connect":false},{"id":16963,"name":"李小英3","sex":null,"email":"Peggytest3@test.com","role":"student","created_at":"2023-12-21 09:51","points":0,"mobile":"0910002426","supervisor":"peggy_lee@liveabc.com","is_email_verified":0,"experience":null,"country":null,"continent":null,"is_promote":0,"is_mobile_verified":0,"service_name":"default","company":"總公司","department":"C","due_at":null,"name_en":"Peggytest3","city":null,"company_type":"","note":null,"photo_url":"https://livetalk-dev.liveabc.com/images/default-user.png","display_name":"Peggytest3","is_line_notify_connect":false}]
        },

        // pagination
        pageIndex: 1,
        pageCount: 10
      }
    },
    methods: {
      toPage (toPage) {
        console.log(toPage)
      }
    }
  }
</script>
<style lang="scss" scoped>
@import "@/assets/styles/color.scss";
.ChatHistory {
  padding: 1rem;
  @media (min-width: 640px) {
    padding: 1.5rem;
  }
  .intro-title {
    color: $main-color;
    font-weight: 700;
    margin-bottom: 0.75rem;
    @media (min-width: 640px) {
      margin-right: 0.5em;
    }
  }
  .custom-dropdown {
    position: relative;
  }
  .custom-dropdown select {
    width: 100%;
    // background: #0E103E;
    color: #0E103E;
    padding-top: .3em;
    padding-bottom: .3em;
    padding-left: 1em;
    padding-right: 3em;
    border: 0;
    margin: 0;
    text-indent: 0.01px;
    text-overflow: '';
    -webkit-appearance: button;
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
  }

  .custom-dropdown::after {
    position: absolute;
    pointer-events: none;
    color: #0E103E;
    content: "\25BC";
    height: 1em;
    font-size: 0.625em;
    line-height: 1;
    right: 1.2em;
    top: 30%;
    @media (min-width: 640px) {
      top: 25%;
    }
  }
}
</style>
